import { Component } from '@angular/core';
import { UtilService } from './services/util.service';
import { Router, ActivatedRoute, NavigationEnd } from '@angular/router';
import { Location } from '@angular/common';
import { DataService } from './services/data.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent {

  title = 'augment-seattle';

  public showFooter: boolean = false;
  public showHeader: boolean = false;
  public showModal: boolean = false;
  public showModalClose: boolean = false;
  public routeUrl: string = "";
  public routeParams: string[] = [];
  public projectId: string = "";
  public modalCloseUrl: string = "";
  public dataLoaded: boolean = false;
  public pageErrorMessage: string = "";

  constructor(
    private router: Router,
    private location: Location,
    private utilService: UtilService,
    private dataService: DataService
  ) {
    this.subscribe();
    this.listeners();
    this.dataService.loadCmsData();
  }

  subscribe() {
    this.dataService.cmsData.subscribe((data) => {
      if (data) {
        this.dataLoaded = true;
      }
    });
    this.dataService.cmsDataErrorMessage.subscribe((message: string) => {
      this.pageErrorMessage = message;
    });
    this.utilService.showFooter.subscribe((shown: boolean) => {
      if (shown) {
        this.showFooter = shown;
      }
    });
    this.utilService.showHeader.subscribe((shown: boolean) => {
      if (shown) {
        this.showHeader = shown;
      }
    });
    this.utilService.showModal.subscribe((shown: boolean) => {
      this.showModal = shown;
    });
    this.utilService.modalCloseUrl.subscribe((closeUrl: string) => {
      console.log('closeUrl', closeUrl);

      this.modalCloseUrl = closeUrl;
    });
    this.router.events.subscribe((route: ActivatedRoute) => {
      if (route instanceof NavigationEnd) {
        // Hide header and footer on home page
        if (route.url === "/") {
          this.utilService.showFooter.next(false);
          this.showFooter = false;
          this.utilService.showHeader.next(false);
          this.showHeader = false;
        } else {
          this.utilService.showFooter.next(true);
          this.showFooter = true;
          this.utilService.showHeader.next(true);
          this.showHeader = true;
        }
        // Show map modal content for child map sub-pages
        if (route.url.indexOf("/map/") === 0) {
          this.setModalShown(true);
          // Show/hide the modal close button
          this.showModalClose = route.url.indexOf("/map/artist/") === 0 || route.url.indexOf("/map/directions") === 0 || route.url.indexOf("/map/how-to-interact") === 0;
          // Update content based on route URL right away
          this.parseRouteUrl(route.url);
        } else {
          this.setModalShown(false);
          setTimeout(() => {
            // Wait for modal to hide before updating the route URL (and changing modal content)
            this.parseRouteUrl(route.url);
          }, 400);
        }
      }
    });
  }

  parseRouteUrl(url: string) {
    this.routeUrl = url;
    this.routeParams = url.split("/").filter((v) => {
      return !!v;
    });
    console.log('routeParams', this.routeParams);
    // Parse out the artist ID
    if (this.routeParams.length === 3 && this.routeParams[0] === "map" && this.routeParams[1] === "artist") {
      this.projectId = this.routeParams[2];
      if (!this.modalCloseUrl) {
        this.modalCloseUrl = "/map/artists";
        this.utilService.modalCloseUrl.next("/map/artists");
      }
    } else {

      this.projectId = "";
      if (this.routeParams[1] !== 'how-to-interact') {
        this.modalCloseUrl = "/map";
        this.utilService.modalCloseUrl.next("/map");
      }
    }
  }

  listeners() {
    this.parseRouteUrl(location.pathname);
  }

  closeModal() {
    console.log('this.modalCloseUrl', this.modalCloseUrl);
    if (this.modalCloseUrl.indexOf('/map/artist/') === 0 && this.routeUrl !== '/map/how-to-interact') {
      this.modalCloseUrl = "/map";
      this.utilService.modalCloseUrl.next("/map");
    }
    this.router.navigate([this.modalCloseUrl]);
    
  }

  setModalShown(shown: boolean) {
    this.showModal = shown;
    this.utilService.showModal.next(shown);
  }

}
